import { Typography } from "@mui/material";

interface ChatMessageProps {
  message: string;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  return (
    <Typography variant="body2" whiteSpace="pre-line">
      {message}
    </Typography>
  );
};
